import { AutogenModelExtraPay, AutogenRowExtraPay } from "./autogen/AutogenModelExtraPay";

export class ModelExtraPay extends AutogenModelExtraPay<RowExtraPay> {
    constructor() {
        super(RowExtraPay);
    }
}

export class RowExtraPay extends AutogenRowExtraPay {
}